module.exports = __webpack_public_path__ + "merriweather-regular-webfont.a1950c7ce0600544ae9b.ttf";


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/assets/fonts/merriweather-regular-webfont.ttf
// module id = ../../../../../src/assets/fonts/merriweather-regular-webfont.ttf
// module chunks = 2